<template lang="pug">
    v-container( fluid )
        v-layout( row wrap )
            v-flex( xs12 )
                v-toolbar( color="primary" dark flat )
                    div.divToolbarGenerateConciliation
                        span.title Búsqueda de cuentas sugeridas
                        v-btn(color="info" dark @click="backPreviousView" ) 
                            v-icon.mr-2 arrow_back 
                            span Volver
                crud-form(
                    :fields="fields"
                    ref="refGenerateConciliationForm"
                    submitText="Generar"
                    noButtons
                    @calculate="calculate"
                    )
                    div(slot="appendContent")
                        crud-data-table(
                            :headers="headersTable"
                            :service="service"
                            :filters="[]"
                            showAll
                            :deleteButton="()=> false"
                            :showButton="()=> false"
                            ref="refDTGenerateConciliation"
                            )
                            template( slot="actions" slot-scope="props" )
                                v-tooltip(bottom)
                                    v-btn(slot="activator" @click="submitGenerateConciliation( props.item )" color="success" icon flat )
                                        v-icon account_balance
                                    span Conciliar
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
    CrudForm,
    CrudDataTable,
    DTService,
} from '@/components/reusable_components'
import FieldsConciliation from './FieldsConciliation'
import HeadersTable from './HeadersTable'
import { getAllAccounts, getAllAccountTypes } from '@/services/api/account'
import {
    fetchSuggest,
    generateConciliation,
} from '@/services/api/accountConciliation'
export default {
    name: 'generate-conciliation',
    // props: {},
    data: function() {
        return {
            fields: FieldsConciliation,
            headersTable: HeadersTable,
            service: {
                dtFetchData: () => {},
            },
            listDetail: [],
            itemConciliate: {},
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        calculate: function() {
            this.getAccountConciliation(
                this.$refs.refGenerateConciliationForm.vmodels.acc_account_id
            )
        },
        // -- Data fetching
        getAccountConciliation: async function(account) {
            const url = process.env.VUE_APP_API_ROUTE.concat(
                `/acc_account_conciliation/suggest?filter[acc_account_id]=${account}`
            )
            this.service.dtFetchData = DTService.getFetchDataFunction(
                url,
                [],
                []
            )
        },
        // -- Data handling and transformations
        submitGenerateConciliation: function(item) {
            //-
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Conciliar')
            //-
            let payload = this.fillSnack(
                'warning',
                '¿Desea realizar la conciliación de cuentas?',
                ''
            )
            this.initSnackbar(payload)
            //-
            this.itemConciliate = item
        },
        // -- Validations and Error handling
        setFieldOptionsData(index, data) {
            this.fields[index].options.data = data
        },
        // -- Other functions
        backPreviousView: function() {
            window.history.back()
        },
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        setFieldOptionsData: function(index, data) {
            this.fields[index].options.data = data
        },
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Conciliar') {
                this.resetSnackbarState()
                //-
                let obj = {}
                obj.acc_debit_accounting_seat_id = this.itemConciliate.acc_debit_accounting_seat_id
                obj.acc_credit_accounting_seat_id = this.itemConciliate.acc_credit_accounting_seat_id
                obj.acc_debit_account_id = this.itemConciliate.acc_account_id
                obj.acc_credit_account_id = this.itemConciliate.acc_account_id
                //-
                let response = await generateConciliation(obj)
                if (response.status == 'success') {
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Cuentas conciliadas con éxito'
                    )
                    //-
                } else {
                    this.showSnackbar('error', 'Error', response.error)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
        'crud-data-table': CrudDataTable,
    },
    // mixins: [],
    // filters: {},
    beforeMount: async function() {
        let response = await getAllAccounts()
        let allAccounts = response.data
        this.setFieldOptionsData(0, allAccounts)
        this.$refs.refGenerateConciliationForm.vmodels.acc_account_id =
            allAccounts[0].id
        this.getAccountConciliation(
            this.$refs.refGenerateConciliationForm.vmodels.acc_account_id
        )
    },
    mounted: function() {
        this.setTitleTopBar('Conciliación de cuentas')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('EDIT_ACCOUNTING_NOTE')) ctx.$router.push('/')
        })
    },
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
.divToolbarGenerateConciliation {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>